import { PartnerEshopSalesEntity, SalesEntity } from '../apiTypes';
import { ApiGroup } from '../model/ApiGroup';

export const mockSalesEntities: SalesEntity[] = [
  {
    code: 'PARTNERS_OWN',
    name: "partner's own",
  },
  {
    code: 'TRADESOLUTION',
    name: 'tradesolution',
  },
  {
    code: 'SALESCONNECT',
    name: 'salesconnect',
  },
  {
    code: 'GETBIGGER',
    name: 'getbigger',
  },
];

export const mockPartnerSalesEntity: SalesEntity = {
  code: 'TRADESOLUTION',
  name: 'tradesolution',
};

const apiGroups = Object.values(ApiGroup);
const entityCodes = ['TRADESOLUTION', 'PARTNERS_OWN', 'SALESCONNECT', 'GETBIGGER'];
const entityNames = ['tradesolution', "partner's own", 'salesconnect', 'getbigger'];
const marketplaces = ['KAUFLAND.CZ', 'ALZA.CZ', 'ALLEGRO.PL', 'MALL.HR'];

const generatePartnerEshopSalesEntitiesMockData = (): PartnerEshopSalesEntity[] => {
  const mockData: PartnerEshopSalesEntity[] = [];
  for (let i = 1; i <= 90; i += 1) {
    const entityIndex = Math.floor(Math.random() * entityCodes.length);
    const apiGroupIndex = Math.floor(Math.random() * apiGroups.length);
    const marketplaceIndex = Math.floor(Math.random() * marketplaces.length);
    const partnerId = Math.ceil(i / 3);
    const marketplaceCode = marketplaces[marketplaceIndex];

    mockData.push({
      salesOrganizationCode: entityCodes[entityIndex],
      salesOrganizationName: entityNames[entityIndex],
      partnerCode: `PARTNER${partnerId}`,
      partnerName: `Partner ${partnerId}`,
      marketplaceCode,
      apiGroup: apiGroups[apiGroupIndex],
    });
  }
  return mockData;
};

export const mockPartnerEshopSalesEntities: PartnerEshopSalesEntity[] = (
  generatePartnerEshopSalesEntitiesMockData()
);
